export const devices = {
    small: '@media (max-width: 500px)',
    large: '@media (orientation: landscape) and (min-width: 1000px)',
}
